module.exports = __webpack_public_path__ + "assets/795c76f26f261814eb8811ff63a153ec.svg";